import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from 'aws-amplify';


@Injectable({
  providedIn: 'root'
})
export class LobbypageService {

  getApiUrl: string = "https://eu8ctuk9ie.execute-api.ap-south-1.amazonaws.com/dev"

  /**
   * Constructor of the Service with Dependency Injection
   * @param http The standard Angular HttpClient to make requests
   */
  constructor(private http: HttpClient) { }

  // getMatches() {
  //   return this.http.get(`${this.getApiUrl}/matches/?timestamp=1525401000&gameId=1&sportId=1`);
  // }
  getMatches1(timestamp) {
    return this.http.get(`${this.getApiUrl}/matches/?${timestamp}&gameId=1&sportId=1`);
  }

}
